

import { DiasFestivosModel } from '@/store/diasFestivos.model';
import { properties } from '@/utils/properties';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DiasFestivosService {

  constructor(private http: HttpClient) { }

  getAll(): Observable<DiasFestivosModel[]> {
    return this.http.get<DiasFestivosModel[]>(properties.URL_CATALOGS + 'diasFestivos', properties.httpOptions);
  } 


   
   
}
